import QueryBuilder from '~/sqlite/services/queryBuilder';
import { Schemas, SQLiteTable } from '~/sqlite/schemas';

export class TableMigrationRegistry {
  private qb = new QueryBuilder();
  private tables: Map<string, SQLiteTable[]> = new Map();

  constructor() {
    this.registerDefaults();
  }

  private registerDefaults(): void {
    Object.entries(Schemas).forEach(([tableName, columns]) => {
      this.registerTable(tableName, columns);
    });
  }

  private registerTable(tableName: string, schema: SQLiteTable[]): void {
    this.tables.set(tableName, schema);
  }

  createTableStatements(): string[] {
    const statements: string[] = [];
    this.tables.forEach((columns, tableName) => {
      if (columns && columns.length > 0) {
        statements.push(this.qb.createTable(tableName));
      }
    });
    return statements;
  }
}

export const tableMigrationRegistry = new TableMigrationRegistry();
